import request from '@/request/request'
// 获取消息列表
export function getMessageList(query) {
    return request({
        url: '/api/message-server/integratedMessage/list',
        method: 'get',
        params: query
    })
}
// 查看消息详情
export function getMessageById(id) {
    return request({
        url: '/api/message-server/integratedMessage/' + id,
        method: 'get',
    })
}

// 手动处理
export function process(data) {
    return request({
        url: '/api/message-server/integratedMessage/process',
        method: 'post',
        data: data
    })
}
